export const getPageTitle = (): string => {
  const hostname = window.location.hostname;
  const defaultTitle = 'Algoricca App';

  // If not an Algoricca domain, return the default title
  if (!hostname.includes('.algoricca.com')) {
    return defaultTitle;
  }

  // Extract the subdomain (part before .algoricca.com)
  const subdomain = hostname.split('.algoricca.com')[0];

  // If there is no subdomain or it's just 'www', return the default title
  if (!subdomain || subdomain === 'www') {
    return defaultTitle;
  }

  // Format the title based on the subdomain
  const formattedTitle = subdomain
    .split('-')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');

  return formattedTitle;
};

export const updatePageTitle = (): void => {
  const title = getPageTitle();
  document.title = title;
};
